import { PaymentActions } from "./payment-methods";

export const warrantyOwnRiskAmount: number = 149;

export const idealId: string = "10";
export const creditCardId: string = "712";
export const klarnaId: string = "2107";
export const sprayPayId: string = "1987";

export const statusSuccess: number = 100;
export const statusDenied: number = -63;
export const statusCancel: number = -90;

export type PaymentTypes = {
  action: PaymentActions;
  methodIds: string[];
};

export type PaymentType = {
  action: PaymentActions;
  methods: PaymentMethod[];
};

export type PaymentMethod = {
  id: string;
  maxAmount: number;
  minAmount: number;
  name: string;
  visibleName: string;
  countries: string[];
  brand?: PaymentMethodBrand;
  banks?: PaymentMethodBank[];
};

export type PaymentMethodBrand = {
  id: string;
  image: string;
  name: string;
  publicDescription: string;
};

export type PaymentMethodBank = {
  id: string;
  image: string;
  name: string;
  visibleName: string;
};

// 100% | 90%
export const PaymentTypesFull: PaymentTypes = {
  action: PaymentActions.PAY_FULL,
  methodIds: [idealId, creditCardId],
};
// 10%
export const PaymentTypesNow: PaymentTypes = {
  action: PaymentActions.PAY_NOW,
  methodIds: [idealId, creditCardId],
};

export const PaymentTypesLaterMonths: PaymentTypes = {
  action: PaymentActions.PAY_LATER_MONTHS,
  methodIds: [sprayPayId],
};
export const PaymentTypesCustom: PaymentTypes = {
  action: PaymentActions.PAY_CUSTOM,
  methodIds: [idealId],
};

export const paymentTypesAll: PaymentTypes[] = [
  {
    action: PaymentActions.PAY_NOW,
    methodIds: [idealId, creditCardId],
  },
  {
    action: PaymentActions.PAY_FULL,
    methodIds: [idealId, creditCardId],
  },
  // {
  //   action: PaymentActions.PAY_LATER_TERMS,
  //   methodIds: [klarnaId],
  // },
  {
    action: PaymentActions.PAY_LATER_MONTHS,
    methodIds: [sprayPayId],
  },
];

export const paymentTypesAllNoMonths: PaymentTypes[] = [
  {
    action: PaymentActions.PAY_NOW,
    methodIds: [idealId, creditCardId],
  },
  {
    action: PaymentActions.PAY_FULL,
    methodIds: [idealId, creditCardId],
  },
];

export const paymentTypesRemaining: PaymentTypes[] = [
  { action: PaymentActions.PAY_FULL, methodIds: [idealId] },
];

export const paymentTypesSampleSale: PaymentTypes[] = [
  { action: PaymentActions.PAY_FULL, methodIds: [idealId] },
  {
    action: PaymentActions.PAY_LATER_MONTHS,
    methodIds: [sprayPayId],
  },
];

export const paymentTypesWarrantyOwnRisk: PaymentTypes[] = [
  { action: PaymentActions.PAY_CUSTOM, methodIds: [idealId] },
];

export const paymentTypesLater: PaymentTypes[] = [
  {
    action: PaymentActions.PAY_LATER_MONTHS,
    methodIds: [sprayPayId],
  },
];

export const paymentTypesCustom: PaymentTypes[] = [
  {
    action: PaymentActions.PAY_CUSTOM,
    methodIds: [idealId],
  },
];

export const paymentTypesBankTransfer: PaymentTypes[] = [
  {
    action: PaymentActions.BANK_TRANSFER,
    methodIds: [],
  },
];
